import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import CajasFrias from '../CadenaDeFrio/CajasFrias.jpg'
import Termos1 from '../CadenaDeFrio/Termos1.jpg'
import { Row, Col, Card, Container } from 'react-bootstrap'

export class ColdChain extends Component {
    render() {
        const products = [
            { 
                img: CajasFrias, 
                title: "Cold Boxes" 
            },
            { 
                img: Termos1, 
                title: "Vaccine Carriers / Thermos" // Traducción técnica más precisa
            }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            {/* Título con la misma jerarquía visual */}
                            <h1>Cold Chain</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Mantenemos el estándar de 2 columnas para el mercado internacional */}
                    <Row xs={1} md={2} lg={2} className="g-5 text-center justify-content-center">
                        {products.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                height: '550px', 
                                                objectFit: 'contain', 
                                                width: '100%',
                                                padding: '20px' 
                                            }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.8rem', padding: '10px' }}>
                                            {item.title}
                                        </Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}